var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape2 = function SvgShape2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.452 5.428a28.42 28.42 0 0 1 33.41 0l46.103 33.495A28.42 28.42 0 0 1 148.29 70.7l-17.61 54.197a28.42 28.42 0 0 1-27.03 19.638H46.664a28.42 28.42 0 0 1-27.03-19.638L2.024 70.699A28.42 28.42 0 0 1 12.35 38.923z",
    opacity: 0.1
  })));
};
export default SvgShape2;